import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import {
  CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Document,
  CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentDocument,
  CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Document,
  CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryDocument,
} from "../../../../../../generated";
import { RelatedCasesTab } from "./related-cases-tab";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface RelatedCasesTabContainerProps {
  caseId: string;
  isArchived?: boolean;
}

export const RelatedCasesTabContainer: React.FC<RelatedCasesTabContainerProps> = (
  props
) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [applicantId, setApplicantId] = useState<string | null>(null);


  const { data: caseData, loading: caseLoading, error: caseError } = useQuery(
    CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Document,
    {
      variables: {
        credentialVerificationCaseV1Id: props.caseId,
      },
      skip: props.isArchived,
    }
  );

  const { loading: archivedApplicantLoading, data: archivedApplicantData, error: archivedApplicantError } = useQuery(
    CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryDocument,
    {
      variables: {
        archivedCredentialVerificationCaseSummaryId: props.caseId,
      },
      skip: !props.isArchived,
    }
  );


  const { loading: applicantLoading, data: applicantData, error: applicantError } = useQuery(
    CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Document,
    {
      variables: {
        credentialVerificationCaseV1Id: props.caseId,
      },
      skip: props.isArchived,
    }
  );

  const { loading } = useQuery(
    CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentDocument,
    {
      variables: {
        applicantId: selectedId,
      },
      skip: !selectedId,
    }
  );

  type MenuInfo = {
    key: React.Key;
  };

  const handleMenuClick = (e: MenuInfo) => {
    if (e.key === "credential-verification") {
      setSelectedId(applicantId);
    } else {
      setSelectedId(null);
    }
  };

   // Effect to update applicantId based on whether the case is archived or not
   useEffect(() => {
    if (props.isArchived) {
      setApplicantId(archivedApplicantData?.archivedCredentialVerificationCaseSummary?.applicant?.id ?? null);
    } else {
      setApplicantId(applicantData?.credentialVerificationCaseV1?.applicant?.id ?? null);
    }
  }, [props.isArchived, archivedApplicantData, applicantData]);

  return (
    <ComponentQueryLoader
      loading={loading || caseLoading || applicantLoading || archivedApplicantLoading}
      error={caseError || archivedApplicantError || applicantError}
      hasData={applicantData?.credentialVerificationCaseV1?.applicant?.id || archivedApplicantData?.archivedCredentialVerificationCaseSummary?.applicant?.id }
      hasDataComponent={
        <RelatedCasesTab
          handleMenuClick={handleMenuClick}
          applicantId={applicantId as string}
          caseId={props.caseId}
          selectedId={selectedId}
          disabled={!caseData?.credentialVerificationCaseV1?.isCurrentUserAssigned || props.isArchived as boolean}
        />
      }
    />
  );
};
